/** 首页输入框 → 画布节点：可创建并自动执行的节点类型 */
export const CANVAS_LAUNCH_NODE_OPTIONS = [
  {
    type: 'scriptWrite',
    label: '剧本创作',
    desc: '根据梗概生成完整剧本',
    icon: 'fas fa-pen-fancy'
  },
  {
    type: 'storyboard',
    label: '分镜脚本',
    desc: '整理剧本为时间轴分镜稿',
    icon: 'fas fa-clapperboard'
  },
  {
    type: 'llm',
    label: '文本节点',
    desc: '大模型文本生成',
    icon: 'fas fa-align-left'
  },
  {
    type: 'image',
    label: '图片',
    desc: '文生图 / 图生图',
    icon: 'fas fa-image'
  },
  {
    type: 'video',
    label: '视频',
    desc: '文生视频 / 图生视频',
    icon: 'fas fa-video'
  },
  {
    type: 'ecomDetail',
    label: '电商详情图',
    desc: '商品详情页批量出图',
    icon: 'fas fa-store'
  },
  {
    type: 'uiDesign',
    label: 'UI 设计',
    desc: '界面设计方案出图',
    icon: 'fas fa-mobile-screen'
  },
  {
    type: 'audio',
    label: '音频节点',
    desc: '语音合成 / 克隆',
    icon: 'fas fa-microphone'
  }
]

export const DEFAULT_CANVAS_LAUNCH_NODE_TYPE = 'scriptWrite'

export function canvasLaunchNodeLabel(type) {
  const t = String(type || '').trim()
  const row = CANVAS_LAUNCH_NODE_OPTIONS.find(x => x.type === t)
  return (row && row.label) || '选择节点'
}
